module.exports = __webpack_public_path__ + "img/privacy-jobmule.884ce364.png";